import {
  // AfterContentInit,
  AfterViewInit,
  Component,
  // EventEmitter,
  inject,
  OnInit,
  // Output,
  ViewChild,
} from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UploadShapefileComponent } from '../../../../shared/components/upload-shapefile/upload-shapefile.component';
import { CommonModule } from '@angular/common';
// import { MatError } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { SmartOrpcClientService } from '../../../../shared/services/smart-orpc-client.service';
import { EnhancedLoadingService } from '../../../../shared/services/enhanced-loading.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarService } from '../../../../shared/services/snackbar.service';

@Component({
  selector: 'app-histories-reports-upload',
  templateUrl: './histories-reports-upload.component.html',
  styleUrls: ['./histories-reports-upload.component.scss'],
  imports: [
    CommonModule,
    //MatError,
    MatIconModule,
    MatButtonModule,
    UploadShapefileComponent,
    MatProgressSpinnerModule,
  ],
})
export class HistoriesReportsUploadComponent implements AfterViewInit, OnInit {
  private orpc = inject(SmartOrpcClientService);
  private loadingService = inject(EnhancedLoadingService);
  private snackBar = inject(SnackbarService);
  @ViewChild('fgbFile')
  declare fgbFileComponent: UploadShapefileComponent;
  @ViewChild('dbfFile')
  declare dbfFileComponent: UploadShapefileComponent;

  fgbFileName: string | null = null;
  dbfFileName: string | null = null;
  requestId?: number;

  dbfFileTypes: string = [
    '.dbf',
    'application/vnd.dbf', //oficial IANA
    'application/dbase',
    'application/x-dbase',
    'application/x-dbf',
    'application/dbf',
    'application/octet-stream',
  ].join(',');

  fgbFileTypes: string = [
    '.fgb',
    'application/vnd.fgb', //oficial IANA
    'application/flatgeobuf',
  ].join(',');

  get fgbHasError() {
    return this.fgbFileComponent?.fileCtrl?.hasError('fgbValidation') || false;
  }
  get dbfHasError() {
    return this.dbfFileComponent?.fileCtrl?.hasError('dbfValidation') || false;
  }

  get fgbErrorMessage() {
    return this.fgbFileComponent?.fileCtrl?.getError('fgbValidation') || {};
  }
  get dbfErrorMessage() {
    return this.dbfFileComponent?.fileCtrl?.getError('dbfValidation') || {};
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    this.requestId = Number(this.route.snapshot.paramMap.get('id'));
  }
  ngAfterViewInit(): void {
    console.log(this.fgbFileComponent);
  }

  async onSubmit() {
    try {
      if (
        this.fgbFileComponent.fileCtrl.invalid ||
        this.dbfFileComponent.fileCtrl.invalid
      ) {
        this.snackBar.alert(
          'Por favor, corrija os erros nos arquivos antes de prosseguir.',
        );
        return;
      }
      this.loadingService.show('button');
      const result =
        await this.orpc.client.historiesSafras.reports.processReportsFiles(
          {
            fgbFileName: this.fgbFileName!,
            dbfFileName: this.dbfFileName!,
            requestId: this.requestId!,
          },
          { context: { errorMessage: 'Erro no processamento dos relatórios' } },
        );

      if (result.success) {
        this.snackBar.alert('Relatórios processados com sucesso!');
        this.navigateToRequestScreen();
      } else {
        this.snackBar.alert('Erro no processamento dos relatórios');
      }
    } finally {
      this.loadingService.hide('button');
    }
  }
  isLoading() {
    return this.loadingService.button$;
  }
  onCancel() {
    this.navigateToDetailScreen();
  }

  private navigateToDetailScreen() {
    this.router.navigate(['/histories-safras/adm/detail/' + this.requestId]);
  }
  private navigateToRequestScreen() {
    this.router.navigate(['/histories-safras']);
  }
  onFileUploadedDbf($event: string | null) {
    this.dbfFileName = $event;
  }
  onFileUploadedFgb($event: string | null) {
    this.fgbFileName = $event;
  }
}
